<template>
  <memlist-card>
    <memlist-static-table
      id="services-table"
      :fields="headers"
      :items="serviceOptions"
      thead-class="d-none"
    >
      <template #cell(id)="row">
        <div class="d-flex align-items-center">
          <memlist-checkbox 
            v-model="row.item.selected"
            @input="onChanged(row.item.id, $event)"
            :title="row.item.name"
          />
          
        </div>
      </template>
    </memlist-static-table>
    <m-row class="mt-4">
      <m-col lg="12">
        <memlist-checkbox 
          v-model="all"
          @input="all_selected"
          :title="`Alla`"

        />
      </m-col>
    </m-row>

  </memlist-card>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';


export default {
  name: 'TransactionServicesSelect',
  components: {
    
  },
  emits: ['onSelectionChanged'],
  data() {
    return {
      all: false,
      serviceOptions: [{ id: 0, selected: false, name: this.$t('COMMON.ALL') }],
      headers: [
        {
          key: 'id',
          label: 'Vald',
          thClass: 'td-short4',
          tdClass: 'td-short4'
        }
      ],
      services: []
    };
  },
  watch: {

  },
  methods: {
    onChanged(id, value) {
      this.$emit('onSelectionChanged', this.serviceOptions);
    },
    all_selected(val) {
      for (const p of this.serviceOptions) {
        p.selected = val;
      }

      this.serviceOptions = [...this.serviceOptions];
    },
    loadServices() {
      this.services = [
        { id: 'spar', name: 'SPAR' },
        { id: 'sinch', name: 'Sinch' },
        { id: 'dintero', name: 'Dintero' },
        { id: 'manual_payment', name: 'Manuell' },
        { id: 'epassi', name: 'Epassi' },
        { id: 'bg', name: 'BGMax' },
        { id: 'stripe', name: 'Stripe' },
        { id: 'swish', name: 'Swish' },
        { id: 'bankid', name: 'BankID' },
        { id: 'memlist_invoice', name: 'Memlist Invoice' },
      ];

      this.serviceOptions = this.services.map(item => ({ id: item.id, name: item.name, selected: false }));

    },
    getData() {

      const ret = [];

      for (const p of this.serviceOptions) {
        if (!p.selected) {
          continue;
        }
        ret.push(p.id);
      }

      return ret;
    },
    reset() {
      this.all = false;
    },
    setServices(service_ids) {
      if (!service_ids) {
        this.reset();
        return;
      }

      for (const p of service_ids) {
        const pO = this.serviceOptions.find(item => item.id === p);

        if (pO) {
          pO.selected = true;
        }
      }

    },
  },
  mounted() {

    this.loadServices();
  }
};
</script>
